var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{on:{"click":_vm.toMessage}},[_c('icon-font',{style:({color: _vm.color}),attrs:{"type":"icon-icon_xiaoxi"}}),_c('van-badge',{staticClass:"badge",attrs:{"content":_vm.messageNo > 0 ? _vm.messageNo : null,"max":"99"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }